import { render, staticRenderFns } from "./dingzhi.vue?vue&type=template&id=c5523776&scoped=true&"
import script from "./dingzhi.vue?vue&type=script&lang=js&"
export * from "./dingzhi.vue?vue&type=script&lang=js&"
import style0 from "./dingzhi.vue?vue&type=style&index=0&id=c5523776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5523776",
  null
  
)

export default component.exports